import styled from "styled-components";

export const Wrapper = styled.div`
  background: #131f28;
  padding: 20px 30px;
  box-shadow: ${props => props.isSmall ? "none" : "0px 0px 15px 1px #00000066"};
  margin-top: ${props => props.isSmall ? "40px" : "0"};

  .heading-container {
    h2 {
      color: #fff;
      margin: 0px;
    }
    h5 {
      color: #afafaf;
      margin: 0px;
      font-size: 17px;
      padding: 15px 0px 30px 0px;
    }
  }

  .sm-heading-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    margin-bottom: 20px;

    .heading-big {
      color: white;
      border: 1px solid #cccccc;
      padding: 5px 10px;
      border-radius: 10px;
    }
    .heading-small {
      color: #cccccc;
    }
  }

  .page-change-button {
    color: #1890ff;
    display: flex;
    justify-content: center;
    padding-top: 10px;
  }

  .test {
    background: #3a96b8;
  font-size: 16px;
  color: white;
  border: 0 none;
  border-radius: 3px;
  cursor: pointer;
  border: 2px solid transparent;
  width: 100%;
  padding-bottom: 35px;
  padding-top: 12px;
  :hover {
    border: 2px solid white;
    background: #3a96b8;
    color: white
  }
  }

`;
